import { render, staticRenderFns } from "./PageToggleTransition.vue?vue&type=template&id=95aca8a2&"
import script from "./PageToggleTransition.vue?vue&type=script&lang=js&"
export * from "./PageToggleTransition.vue?vue&type=script&lang=js&"
import style0 from "./PageToggleTransition.vue?vue&type=style&index=0&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports